import React from "react";

function Footer() {
    return (
        <div className="bg-[#F0F0F0] h-auto mt-20 px-10 py-10">
            <div className=" w-full h-full flex flex-row gap-36 items-start justify-center">
                <div className="flex flex-col items-start justify-start gap-5">
                    <div className="font-bold text-xl">CLOVER</div>
                    <div className="font-bold text-lg">Stay in the loop.</div>
                    <div className=" text-gray-600 text-sm">Sign up for email updates today.</div>
                    <div className="w-full relative">
                        <input type="text" className="w-full bg-transparent box-border border-2 border-black border-solid focus:outline-none h-[2.5rem] pl-2" />
                        <div className=" absolute bottom-7 px-1 left-5 bg-[#F0F0F0]">Email Address</div>
                    </div>
                    <div className="text-left text-sm text-gray-400">By providing your email, you agree to the Terms of Use and Privacy Policy. You may later unsubscribe</div>
                </div>

                <div className="text-sm flex flex-col items-start justify-start text-left w-[22rem] gap-1">
                    <div className=" relative flex flex-row justify-center items-center">
                        <div className="absolute left-[-2rem] top-[-1px]">
                            <span className="material-symbols-outlined">call</span>
                        </div>
                        <div className=" font-semibold">Phone Support</div>
                    </div>
                    <div className="mt-5">007 803 651 0087</div>
                    <div>Mon - Fri: 0800 - 17</div>
                    <div>00 (GMT+7)</div>
                    <div>Closed on Public Holidays in Singapore</div>
                    <div className="mt-5 relative flex flex-row justify-center items-center">
                        <div className="absolute right-20 top-[-1px]">
                            <span className="material-symbols-outlined">mail</span>
                        </div>
                        <div className="font-semibold">Contact Us</div>
                    </div>
                </div>
                <div className="text-sm flex flex-col items-start justify-start text-left w-[22rem] gap-1">
                    <div className=" relative flex flex-row justify-center items-center">
                        <div className="font-semibold">Customer Service</div>
                    </div>
                    <div className="mt-5">Help & FAQ</div>
                    <div>Size Guide</div>
                    <div>Shipping & Delivery</div>
                    <div>Returns</div>
                    <div>Store Locator</div>
                    <div>Order Tracking</div>
                    <div>Sitemap</div>
                </div>
                <div className="text-sm flex flex-col items-start justify-start text-left w-[22rem] gap-1">
                    <div className=" relative flex flex-row justify-center items-center">
                        <div className="font-semibold">About Clover</div>
                    </div>
                    <div className="mt-5">Affiliates</div>
                    <div>About Us/Our Story</div>
                    <div>Shipping & Delivery</div>
                    <div>Our Technology</div>
                    <div>Careers</div>
                </div>

            </div>
        </div>
    );
}

export default Footer;
